// headers.ts

// Define header names
export const JOB_ID = "Job Id";
export const REPORTED_ISSUE = "Reported issue";
export const CUSTOMER_NAME = "Customer name";
export const TECHNICIANS = "Technicians";
export const PRIORITY_LEVEL = "Priority level";
export const STATUS = "Status";
export const WARRANTY_START_DATE = "Warranty start date";
export const WARRANTY_END_DATE = "Warranty end date";
export const END_DATE_LABEL = "End date";
export const START_DATE = "Start date";
export const COMPLETION_DATE = "Completion date";
export const JOB_CARD_PRODUCTS = "Job card products";

// You can add more header names as needed for your reports

export const VENDOR_NAME = "Vendor name";
export const DELIVERY_DATE = "Delivery date";
export const PO_STATUS = "PO status";
export const PRODUCT_CODE = "Product code";
export const QUANTITY = "Quantity";
export const ORDER_QUANTITY = "Order quantity";
export const RECEIVED_QUANTITY = "Received quantity";

export const ORDER_ID = "Order Id";
export const ORDER_TYPE = "Order Type";
export const PROJECT_NAME = "Project Name";
export const ORDER_DATE = "Order Date";
export const Quantity = "Quantity";
export const TOTAL_PRICE = "Total Amount";
export const RECEIVED_AMOUNT = "Received Amount";
export const OUTSTANDING_AMOUNT = "Outstanding Amount";
export const PAYMENT_STATUS = "Payment Status";

export const getPaymentStatusColor = (status: string) => {
  switch (status) {
    case "In Progress":
      return { backgroundColor: "#299cdb", color: "white" };
    case "Closed":
      return { backgroundColor: "#45CB85", color: "white" };
      case "Reopen":
      return { backgroundColor: "#dc3545", color: "white" };
    case "High":
      return { backgroundColor: "#dc3545", color: "white" };
    case "Medium":
      return { backgroundColor: "#299cdb", color: "white" };
    case "Low":
      return { backgroundColor: "#45CB85", color: "white" };
    case "Partially Returned":
      return { backgroundColor: "#299cdb", color: "white" };
    case "Partially Billed":
      return { backgroundColor: "#299cdb", color: "white" };
    case "Paid":
      return { backgroundColor: "#45CB85", color: "white" };
    case "Returned":
      return { backgroundColor: "#dc3545", color: "white" };
    case "Partially Paid":
      return { backgroundColor: "#299cdb", color: "white" };
    case "Received":
      return { backgroundColor: "#45CB85", color: "white" };
    case "Billed":
      return { backgroundColor: "#45CB85", color: "white" };
    case "Pending":
      return { backgroundColor: "#ffbe0b", color: "white" };
   
    default:
      return {}; // Default style for other statuses
  }
};

export const priorities = [
  { label: "High", value: "High" },
  { label: "Medium", value: "Medium" },
  { label: "Low", value: "Low" },
];

export const statuses = [
  { label: "In Progress", value: "In Progress" },
  { label: "Closed", value: "Closed" },
  { label: "Reopen", value: "Reopen" },
];

export const po_status = [
  { label: "Received", value: "Received" },
  { label: "Billed", value: "Billed" },
  {label:"Pending", value: "Pending"}
];

export const OrderTypeList = [
  { label: "Customer", value: "Customer" },
  { label: "Internal", value: "Internal" },
];

export const PaymentStatus = [
  { label: "Partially Returned", value: "Partially Returned" },
  { label: "Paid", value: "Paid" },
  { label: "Returned", value: "Returned" },
  { label: "Partially Paid", value: "Partially Paid" },
  { label: "Pending", value: "Pending" },
];
